import * as React from 'react';
import { useSensitivityLabel_unstable } from './useSensitivityLabel';
import { renderSensitivityLabel_unstable } from './renderSensitivityLabel';
import { useSensitivityLabelStyles_unstable } from './useSensitivityLabelStyles';
import type { SensitivityLabelProps } from './SensitivityLabel.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// SensitivityLabel component - TODO: add more docs
export const SensitivityLabel: ForwardRefComponent<SensitivityLabelProps> = React.forwardRef((props, ref) => {
  const state = useSensitivityLabel_unstable(props, ref);

  useSensitivityLabelStyles_unstable(state);
  return renderSensitivityLabel_unstable(state);
});

SensitivityLabel.displayName = 'SensitivityLabel';
